import { create } from "zustand";

export type UiState = {
  sidebarCollapsed: boolean;
};

export type UiActions = {
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
};

const STORAGE_KEY = "kkp.ui.sidebarCollapsed";

function safeLoadCollapsed(): boolean {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === null) return false;
    return raw === "1";
  } catch {
    return false;
  }
}

function safeSaveCollapsed(value: boolean): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, value ? "1" : "0");
  } catch {
    // ignore storage errors (private mode, blocked, etc.)
  }
}

/**
 * UI store (Zustand) for lightweight session/UI state.
 * - Manages sidebar collapse state (per BLUEPRINT guidance).
 */
export const useUiStore = create<UiState & UiActions>((set) => ({
  sidebarCollapsed: safeLoadCollapsed(),
  toggleSidebar: () =>
    set((state) => {
      const next = !state.sidebarCollapsed;
      safeSaveCollapsed(next);
      return { sidebarCollapsed: next };
    }),
  setSidebarCollapsed: (collapsed) =>
    set(() => {
      safeSaveCollapsed(collapsed);
      return { sidebarCollapsed: collapsed };
    }),
}));
